import React from 'react';

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading__box">
        <span className="loading__loader"/>
        {/* <p className="loading__text">Cargando...</p> */}
      </div>
    </div>
  );
};

export default Loading;
